import { formatUnits } from "@ethersproject/units"
import type { BigNumber } from "ethers"

export function bnNumberOrZero(bn?: BigNumber, units = 18) {
  const stringNumber = units ? formatUnits(bn || 0, units) : bn?.toString() || "0.0"

  const [numberBeforeDot, numberAfterDot] = stringNumber.split(".")
  if (!numberAfterDot) {
    return Number(numberBeforeDot)
  }
  return Number(`${numberBeforeDot}.${numberAfterDot.slice(0, 10)}`)
}
